import "amfe-flexible"; // 引入 lib-flexible
import { createApp } from "vue";
import App from "./App.vue";
import Antd from "ant-design-vue";
import "ant-design-vue/dist/reset.css";
import router from "./router";
import store from "./store";

import TopBar from "@/components/TopBar.vue";
import BottomBar from "@/components/BottomBar.vue";

// 动态调整根字体大小的函数
const updateRootFontSize = () => {
  const baseSize = 16; // 基准字体大小
  const minFontSize = 10; // 最小字体大小
  const maxFontSize = 20; // 最大字体大小
  const designWidth = 1920; // 设计稿的宽度基准
  const clientWidth = document.documentElement.clientWidth; // 当前窗口的宽度
  const scale = clientWidth / designWidth; // 计算当前窗口宽度与设计稿宽度的比例
  let newSize = baseSize * scale;

  // 限制字体大小在最小和最大范围内
  if (newSize < minFontSize) {
    newSize = minFontSize;
  } else if (newSize > maxFontSize) {
    newSize = maxFontSize;
  }

  // 设置根元素的字体大小
  document.documentElement.style.fontSize = `${newSize}px`;
};

// 监听窗口大小变化，并动态调整字体大小
window.addEventListener("resize", updateRootFontSize);
// 初始化时立即设置一次字体大小
updateRootFontSize();

createApp(App)
  .use(Antd)
  .use(store)
  .use(router)
  .component("TopBar", TopBar)
  .component("BottomBar", BottomBar)
  .mount("#app");
